var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS2IconCommentText20N({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10313 17.1C6.01392 17.1 5.92427 17.0824 5.83901 17.0464C5.58984 16.94 5.42813 16.6957 5.42813 16.425V13.5H4.275C2.41392 13.5 0.9 11.9856 0.9 10.125V5.175C0.9 3.31436 2.41392 1.8 4.275 1.8H13.725C15.5861 1.8 17.1 3.31436 17.1 5.175V10.125C17.1 11.9856 15.5861 13.5 13.725 13.5H10.1145L6.57114 16.911C6.44282 17.035 6.27451 17.1 6.10313 17.1ZM4.275 3.15C3.15835 3.15 2.25 4.05879 2.25 5.175V10.125C2.25 11.2412 3.15835 12.15 4.275 12.15H6.10313C6.47578 12.15 6.77813 12.4523 6.77813 12.825V14.8386L9.37442 12.339C9.5001 12.2177 9.66797 12.15 9.84244 12.15H13.725C14.8416 12.15 15.75 11.2412 15.75 10.125V5.175C15.75 4.05879 14.8416 3.15 13.725 3.15H4.275Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.025 9.45H6.075C5.70235 9.45 5.4 9.14765 5.4 8.775C5.4 8.40235 5.70235 8.1 6.075 8.1H11.025C11.3977 8.1 11.7 8.40235 11.7 8.775C11.7 9.14765 11.3977 9.45 11.025 9.45Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.925 6.75H6.075C5.70235 6.75 5.4 6.44765 5.4 6.075C5.4 5.70235 5.70235 5.4 6.075 5.4H11.925C12.2977 5.4 12.6 5.70235 12.6 6.075C12.6 6.44765 12.2977 6.75 11.925 6.75Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2IconCommentText20N);
export default __webpack_public_path__ + "static/media/S2_Icon_CommentText_20_N.03d095ea58725861e16ef209b98d4bd0.svg";
export { ForwardRef as ReactComponent };